import axios from "axios";

export default function AfficheCommandeCommercial(){
    const GetCommandeCommercial=(id?: string)=>{
        const url = id 
            ? `${process.env.REACT_APP_PHP_APP_URL}/commercial/${id}/commandes`
            : `${process.env.REACT_APP_PHP_APP_URL}/admin/commercial/commande`;
        return (axios.get(url));
    }
    return {
        GetCommandeCommercial
    }
}